import React from "react";
import "../styles/style.css";
import HeaderSerene from "../components/HeaderSerene";
import HeroWoods from "../components/cybermeadows/HeroCyber";
import WoodsLogo from "../assets/cyber-meadows-images/cyber-meadows-logo-web.png";
import "../styles/CyberMeadows.css";
import AboutWoods1 from "../components/cybermeadows/AboutCyber1";
import ContactWoods from "../components/cybermeadows/ContactWoods";
import AboutWoods from "../components/cybermeadows/AboutWoods";
import WoodsMasterplan from "../components/cybermeadows/CyberMasterplan";
import LocationCyber from "../components/cybermeadows/LocationCyber";
import FloorPlansCyber from "../components/cybermeadows/FloorPlansCyber";

const menuLinks = [
  { label: "ABOUT WOODS", target: "about-serene" },
  // { label: "AMENITIES", target: "woods-clubhouse" },
  { label: "MASTERPLAN", target: "woods-masterplay" },
  { label: "FLOOR PLANS", target: "cyber-floor-plans" },
  { label: "LOCATION", target: "woods-location" },
  // { label: "SPECIFICATIONS", target: "serene-specifications" },
  { label: "CONTACT", target: "serene-contact" },
];
function CyberMeadows() {
  return (
    <section id="home-cyber">
      <HeaderSerene logo={WoodsLogo} menuLinks={menuLinks} />
      <HeroWoods />
      <AboutWoods />
      <AboutWoods1 />
      <WoodsMasterplan />
      <FloorPlansCyber />
      <LocationCyber />
      <ContactWoods />
    </section>
  );
}

export default CyberMeadows;
